import { render, staticRenderFns } from "./CrudMessageResponse.vue?vue&type=template&id=0d10ba22&"
import script from "./CrudMessageResponse.vue?vue&type=script&lang=js&"
export * from "./CrudMessageResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports